var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserRole } from '../../customerservice/constants/user-role.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { Constants, DefaultTicketType } from '../common/constants';
import { SearchRequestConstants } from '../common/search-request-constants';
import { ComposeEmailTicketConstants } from '../constants/compose-email.constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { Status } from '../enums/ticket-status.enum';
import { TicketType } from '../enums/ticket-type.enum';
import { SearchModel } from '../interface/ticketingsystem/search.model';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from './../services/department.service';
var MyTicketsComponent = /** @class */ (function () {
    function MyTicketsComponent(_cacheService, _formbulider, _dataShareService, _commonService, _customerservice, departmentService, _translatePipe, messageService, chRef) {
        this._cacheService = _cacheService;
        this._formbulider = _formbulider;
        this._dataShareService = _dataShareService;
        this._commonService = _commonService;
        this._customerservice = _customerservice;
        this.departmentService = departmentService;
        this._translatePipe = _translatePipe;
        this.messageService = messageService;
        this.chRef = chRef;
        this.rightContentWidth = 1000;
        this.active = true;
        this.tabs = new Array();
        this.existedValues = new Array();
        this.justifyingTabs = false;
        this.myTickets = new Array();
        this.allTickets = new Array();
        this.isClearClicked = false;
        this.showAllTickets = false;
        this.createdByOnSelectAll = true;
        this.pageNumber = 1;
        this.pageSize = 25;
        this.pageCount = 0;
        this.isDesc = true;
        this.pageSizes = [10, 25, 50, 75];
        this.sortColumn = 'TICKET_NUMBER';
        this.sort = 'DESC';
        this.disputeSearch = false;
        this.ticketTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.disputeReasonOnSelectAll = true;
        this.excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
        /**
         * Pagination instance - to avoid console warnings - inorder to assign id for pagination
         */
        this.paginationInstance = {
            id: 'my-tickets-pagination',
            itemsPerPage: 10,
            currentPage: 1
        };
        this.dropdownSettings = {
            sourceDropdownList: [],
            sourceSelectedItems: [],
            sourceIndex: 1,
            typeDropdownList: [],
            typeSelectedItems: [],
            typeIndex: 2,
            subTypeDropdownList: [],
            subTypeSelectedItems: [],
            subTypeIndex: 3,
            statusDropdownList: [],
            statusSelectedItems: [],
            statusIndex: 4,
            priorityDropdownList: [],
            prioritySelectedItems: [],
            priorityIndex: 5,
            departmentDropdownList: [],
            departmentSelectedItems: [],
            departmentIndex: 6,
            createdByDropdownList: [],
            createdBySelectedItems: [],
            createdByIndex: 7,
            disputeReasonDropdownList: [],
            disputeReasonSelectedItem: [],
            disputeReasonIndex: 8,
            settings: {},
        };
    }
    MyTicketsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.tabModel = new ViewTabModel();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_TICKETS_VIEW + ']'), AccessLevel.Customer_Service);
        this.active = false;
        this.activetab = 1;
        this.countryId = this.getAllowedCountries();
        this.buildForm();
        this.getOperatingCountries();
        this.fieldTypes = new SearchRequestConstants();
        this.ticketSearchModel = new SearchModel;
        this.getTicketStatus();
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketPriorities();
        this.subTypesSort();
        this.ticketTypesSort();
        // this.getDisputeReasons();
        this.allfieldsDisable = false;
        this._translatePipe.get('Country is required for selected CMS Group');
        this._dataShareService.customerServiceMessage.subscribe(function (message) {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                _this.rightContentWidth = parseInt(splittedMessage[0]);
            }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.isDiputeTicketSearch ? this.disputeSearch = true : '';
    };
    MyTicketsComponent.prototype.intializeMultiselectDropdowns = function () {
        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.priorityDropdownList = [];
        this.dropdownSettings.prioritySelectedItems = [];
        this.dropdownSettings.createdByDropdownList = [];
        this.dropdownSettings.createdBySelectedItems = [];
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this.dropdownSettings.settings = {
            text: 'Select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
            disabled: false
        };
    };
    MyTicketsComponent.prototype.selectTab = function (tab) {
        this.activetab = tab;
    };
    MyTicketsComponent.prototype.changeTab = function (tab) {
        this.activetab = tab;
    };
    MyTicketsComponent.prototype.doNotRemoveFormData = function () {
        //data should not be removed...
    };
    MyTicketsComponent.prototype.subscribeTabContent = function () {
        var _this = this;
        this.messageService.getCustomerServiceTabContent().subscribe(function (data) {
            if (data) {
                _this.id = data.id;
                _this.tabTitle = data.tabName;
                _this.componentName = data.componentName;
                _this.addNewTab();
                _this.justifyingTabs = (_this.tabs && _this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                _this.messageService.setOpenTabsInfo((_this.tabs && _this.tabs.length) ? true : false);
            }
        });
    };
    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
  */
    MyTicketsComponent.prototype.subscribeClosedTabs = function () {
        var _this = this;
        this.messageService.getCloseTabsEvent().subscribe(function (data) {
            if (data) {
                _this.closeAllOpenedTabs();
            }
        });
    };
    MyTicketsComponent.prototype.addNewTab = function () {
        this.tabModel = new ViewTabModel();
        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array();
        var index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            this.displayAlertBoxOnReachingMaxTabs();
        }
        else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            }
            else {
                var selectedId_1 = this.id;
                this.tabs.forEach(function (x) {
                    if (x.id !== selectedId_1) {
                        x.active = false;
                    }
                    else {
                        x.active = true;
                    }
                });
            }
        }
    };
    /*
form data to download to pdf/ csv/print
*/
    MyTicketsComponent.prototype.Download = function () {
        var _this = this;
        var rowdata = new Array();
        var finalrows = new Array();
        var columns = [
            this._translatePipe.get('ticketing-system.Priority')['value'],
            this._translatePipe.get('ticketing-system.Ticket#')['value'],
            this._translatePipe.get('ticketing-system.Subject')['value'],
            this._translatePipe.get('ticketing-system.Ticket Subtype')['value'],
            this._translatePipe.get('ticketing-system.Dispute Reason')['value'],
            this._translatePipe.get('ticketing-system.Status')['value'],
            this._translatePipe.get('ticketing-system.Due Date')['value'],
            this._translatePipe.get('ticketing-system.Created Date')['value'],
            this._translatePipe.get('ticketing-system.Created By')['value'],
            this._translatePipe.get('ticketing-system.Last Modified Date')['value']
        ];
        this._customerservice.SearchTicketsOnPagination(null, [this.userInfo.userId], this.myTicketsForm.value.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.myTicketsForm.value.overDueCount, null, this.myTicketsForm.get('email').value ? this.myTicketsForm.get('email').value : null, this.myTicketsForm.get('email').value ? this.myTicketsForm.get('operatingCountryId').value : null, (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map(function (item) { return item.id; }) : []), true).subscribe(function (response) {
            if (response && response['content']) {
                var tickets = response['content'];
                for (var i = 0; i < tickets.length; i++) {
                    rowdata = [];
                    var a1 = tickets[i];
                    rowdata.push(a1.priorityValue);
                    rowdata.push('\t' + a1.ticketNumber);
                    rowdata.push(a1.subject);
                    rowdata.push(a1.subType);
                    rowdata.push(a1.disputeReasonName ? a1.disputeReasonName : '');
                    rowdata.push(a1.status);
                    rowdata.push(a1.dueDate ? moment.utc(a1.dueDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    rowdata.push(a1.createdDate ? moment.utc(a1.createdDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    rowdata.push(a1.createdByName ? a1.createdByName : '');
                    rowdata.push(a1.modifiedDate ? moment.utc(a1.modifiedDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    finalrows.push(rowdata);
                }
            }
            var title = _this._translatePipe.get('ticketing-system.My Tickets')['value'];
            _this._customerservice.ExcelDownload(columns, finalrows, 'My Tickets', title);
        });
    };
    /**
     * removes tab at specific index
     * @param tab
     */
    MyTicketsComponent.prototype.removeTabHandler = function (tab) {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        }
    };
    /**
     * Close all opened tabs
     */
    MyTicketsComponent.prototype.closeAllOpenedTabs = function () {
        this.tabs = []; //new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
    };
    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    MyTicketsComponent.prototype.displayAlertBoxOnReachingMaxTabs = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    };
    MyTicketsComponent.prototype.openDropDown = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute('hidden');
    };
    MyTicketsComponent.prototype.onDropDowneBlur = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute('hidden', 'true');
    };
    MyTicketsComponent.prototype.getAssignedUsersByDepartments = function (departmentIds, onLoad) {
        var _this = this;
        if (departmentIds) {
            this.dropdownSettings.createdByDropdownList = [];
            this.dropdownSettings.createdBySelectedItems = [];
            this._customerservice.getAssignedUsersByDepartmentIds(departmentIds).subscribe(function (response) {
                if (response) {
                    _this.users = response;
                    _this.users.forEach(function (item) {
                        _this.dropdownSettings.createdByDropdownList.push({ id: item.id, itemName: item.name.trim() });
                    });
                    if (_this.dropdownSettings != null) {
                        if (_this.dropdownSettings.createdByDropdownList != null && !_this.dropdownSettings.createdByDropdownList.find(function (user) { return user.id === 1; })) {
                            _this.dropdownSettings.createdByDropdownList.push({ id: 1, itemName: UserRole.SuperAdministrator });
                        }
                    }
                    _this.dropdownSettings.createdByDropdownList.sort(function (item1, item2) {
                        var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                        if (tickettype1 < tickettype2) {
                            return -1;
                        }
                        if (tickettype1 > tickettype2) {
                            return 1;
                        }
                        return 0;
                    });
                    if (onLoad) {
                        _this.dropdownSettings.createdBySelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.createdByDropdownList));
                        _this.onSearch();
                    }
                    if (_this.isClearClicked) {
                        _this.onSearch();
                        _this.isClearClicked = false;
                    }
                }
                else {
                    _this.users = [];
                    _this.dropdownSettings.createdByDropdownList = [];
                    _this.dropdownSettings.createdBySelectedItems = [];
                }
            });
        }
    };
    MyTicketsComponent.prototype.buildForm = function () {
        this.myTicketsForm = this._formbulider.group({
            ticketNumber: [''],
            operatingCountryId: [this.countryId],
            type: [''],
            subType: [''],
            disputeReason: [''],
            source: [''],
            department: [''],
            status: [''],
            priority: [''],
            showAllTickets: [false],
            overDueCount: [false],
            email: ['', [Validators.pattern(ComposeEmailTicketConstants.EMAIL_REGEXP)]],
            createdBy: []
        });
    };
    MyTicketsComponent.prototype.ShowTicketAndDepatrmentBycountry = function (countryId) {
        this.countryId = countryId;
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.sourceTypes = [];
        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.departments = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.createdByDropdownList = [];
        this.dropdownSettings.createdBySelectedItems = [];
        this.disputeReason = [];
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        // this.getDisputeReasons();
    };
    MyTicketsComponent.prototype.getEditPermission = function (departmentId) {
        if (departmentId) {
            var isView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_DEPARTMENT_TICKETS_EDIT + ']'), AccessLevel.Department, departmentId);
            return isView;
        }
        else {
            return false;
        }
    };
    /**
   * display alert box if the logged in user do not have permission to see the fbo/retail information
   */
    MyTicketsComponent.prototype.displayAlertbox = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    };
    MyTicketsComponent.prototype.getDepartments = function () {
        var _this = this;
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.countryId).subscribe(function (response) {
            if (response) {
                _this.departments = response;
                if (_this.departments) {
                    _this.departments.sort(function (item1, item2) {
                        var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase();
                        if (dept1 < dept2) {
                            return -1;
                        }
                        if (dept1 > dept2) {
                            return 1;
                        }
                        return 0;
                    });
                    if (!_this.userInfo.hasSystemRole) {
                        if (_this.userInfo.privileges.departments && _this.userInfo.privileges.departments.length > 0) {
                            var departmentIds_1 = _this.userInfo.privileges.departments.map(function (a) { return a.id; });
                            _this.departments = _this.departments.filter(function (item) {
                                return departmentIds_1.indexOf(item.id) != -1;
                            });
                        }
                    }
                    _this.departments.forEach(function (item) {
                        _this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value });
                    });
                    _this.dropdownSettings.departmentSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.departmentDropdownList));
                    if (_this.dropdownSettings.departmentSelectedItems && _this.dropdownSettings.departmentSelectedItems.length > 0) {
                        _this.getAssignedUsersByDepartments(_this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }), true);
                    }
                    //this.onSearch();
                }
            }
        });
    };
    MyTicketsComponent.prototype.subTypesSort = function () {
        this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
            if (tickettype1 < tickettype2) {
                return -1;
            }
            if (tickettype1 > tickettype2) {
                return 1;
            }
            return 0;
        });
    };
    MyTicketsComponent.prototype.ticketTypesSort = function () {
        this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
            if (tickettype1 < tickettype2) {
                return -1;
            }
            if (tickettype1 > tickettype2) {
                return 1;
            }
            return 0;
        });
    };
    MyTicketsComponent.prototype.getTicketTypesAndSubTypes = function () {
        var _this = this;
        this.departmentService.getTicketTypesAndSubTypes(this.countryId).subscribe(function (response) {
            if (response && !_this.isDiputeTicketSearch) {
                _this.ticketTypes = response;
                if (_this.ticketTypes.length == 0) {
                    _this.dropdownSettings.typeDropdownList = [];
                    _this.dropdownSettings.subTypeDropdownList = [];
                    _this.dropdownSettings.subTypeSelectedItems = [];
                    _this.dropdownSettings.typeSelectedItems = [];
                }
                else if (_this.ticketTypes.length > 0) {
                    _this.ticketTypes.forEach(function (item) {
                        var operatingCountryName;
                        if (item.operatingCountryName !== null) {
                            operatingCountryName = item.operatingCountryName.trim();
                        }
                        else if (item.operatingCountryName === null && (item.value == DefaultTicketType.Orders || item.value == DefaultTicketType.Products)) {
                            operatingCountryName = 'ALL';
                        }
                        var ticketType = operatingCountryName + ' ' + '-' + ' ' + item.value.trim();
                        _this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: ticketType });
                        if (ticketType.includes('FLP360')) {
                            item.subTypes.forEach(function (subType) {
                                var subTypeName = subType.name.trim() + '(' + item.value.trim() + ')';
                                _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            });
                        }
                        else {
                            item.subTypes.forEach(function (subType) {
                                _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            });
                        }
                        _this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.subTypeDropdownList));
                        if (item.value === TicketType.Order) {
                            _this.getDisputeReasons();
                        }
                    });
                    _this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                        var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                        if (tickettype1 < tickettype2) {
                            return -1;
                        }
                        if (tickettype1 > tickettype2) {
                            return 1;
                        }
                        return 0;
                    });
                    _this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                        var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                        if (tickettype1 < tickettype2) {
                            return -1;
                        }
                        if (tickettype1 > tickettype2) {
                            return 1;
                        }
                        return 0;
                    });
                    _this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.typeDropdownList));
                    // this.getDisputeReasons();
                }
                else if (response && _this.isDiputeTicketSearch) {
                    _this.ticketTypes = response.filter(function (type) { return type.value === TicketType.Order; });
                    _this.ticketTypes.forEach(function (item) {
                        _this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: item.value.trim() });
                        _this.dropdownSettings.typeSelectedItems.push({ id: item.id, itemName: item.value.trim() });
                    });
                    var selectedIds_1 = _this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                    _this.dropdownSettings.subTypeDropdownList = [];
                    _this.dropdownSettings.subTypeSelectedItems = [];
                    _this.ticketTypes.filter(function (item) { return selectedIds_1.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                        if (type.value.includes('FLP360')) {
                            _this.subTypesSort();
                            type.subTypes.forEach(function (subType) {
                                var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                                _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                                _this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subTypeName });
                            });
                        }
                        else {
                            _this.subTypesSort();
                            type.subTypes.forEach(function (subType) {
                                _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                                _this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subType.name.trim() });
                            });
                        }
                    });
                    _this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.typeDropdownList));
                    // this.getDisputeReasons();
                }
            }
        });
    };
    /**
     * @description to Search Tickets
     * @date 2020-01-31
     * @param {boolean} [tabChange]
     * @memberof MyTicketsComponent
     */
    MyTicketsComponent.prototype.onSearch = function (tabChange) {
        var searchBtn = document.getElementById('search-button');
        if (searchBtn) {
            searchBtn.classList.add('button-active');
            setTimeout(function () {
                searchBtn.classList.remove('button-active');
            }, 1000);
        }
        if (!tabChange) {
            this.pageNumber = 1;
        }
        else {
            this.pageNumber = isNaN(this.pageNumber) ? 1 : this.pageNumber;
        }
        this.getTicketsSearch();
    };
    MyTicketsComponent.prototype.searchWithTicketNumber = function () {
        if (this.ticketSearchModel.ticketNumber || this.myTicketsForm.get('email').value) {
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: true });
            this.chRef.detectChanges();
            this.myTicketsForm.controls['overDueCount'].disable();
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
            this.OnTabSearchFocus();
        }
        else {
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
            this.chRef.detectChanges();
            this.myTicketsForm.controls['overDueCount'].enable();
        }
    };
    MyTicketsComponent.prototype.getSourceTypes = function () {
        var _this = this;
        if (this.sourceTypes) {
            this.getDepartments();
            this.sourceTypes.forEach(function (item) {
                _this.dropdownSettings.sourceDropdownList.push({ id: item.id, itemName: item.value });
            });
            this.dropdownSettings.sourceSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.sourceDropdownList));
        }
        else {
            this.sourceTypes = [];
            this.departments = [];
            this.dropdownSettings.departmentDropdownList = [];
            this.dropdownSettings.departmentSelectedItems = [];
        }
    };
    MyTicketsComponent.prototype.getTicketPriorities = function () {
        var _this = this;
        if (this.ticketPriorities) {
            this.ticketPriorities.forEach(function (item) {
                _this.dropdownSettings.priorityDropdownList.push({ id: item.id, itemName: item.value.trim() });
            });
            this.dropdownSettings.prioritySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.priorityDropdownList));
        }
    };
    MyTicketsComponent.prototype.getTicketStatus = function () {
        var _this = this;
        if (this.statusTypes) {
            this.dropdownSettings.statusSelectedItems = [];
            this.statusTypes.forEach(function (item) {
                _this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                if (item.id === Status.InProgress || item.id === Status.New
                    || item.id === Status.OnHold) {
                    _this.dropdownSettings.statusSelectedItems.push({ id: item.id, itemName: item.value });
                }
                _this.statusOnSelectAll = false;
            });
        }
    };
    MyTicketsComponent.prototype.showAllTicketsCheckBox = function (event) {
        this.dropdownSettings.statusSelectedItems = [];
        if (event.target.checked) {
            this.showAllTickets = true;
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
        }
        else {
            this.showAllTickets = false;
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.filter(function (item) { return item.id === Status.InProgress; });
        }
    };
    /**
     * sort table by respective column
     * @param sortColumn
     */
    MyTicketsComponent.prototype.sortTableByColumn = function (sortColumn) {
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? 'DESC' : 'ASC';
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.myTickets.length === 0) {
            return;
        }
        this.getTicketsSearch();
    };
    /**
       * On Page change
       * @param pageNumber
       */
    MyTicketsComponent.prototype.pageChange = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getTicketsSearch();
        }
    };
    MyTicketsComponent.prototype.myTicketsSearchFormSubmit = function () {
        this.pageNumber = 1;
        this.getTicketsSearch();
    };
    MyTicketsComponent.prototype.getOverDueCount = function () {
        var _this = this;
        this._customerservice.getOverDueCount(null, [this.userInfo.userId], this.myTicketsForm.value.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 ? this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }) : []), ([Status.InProgress]), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, true).subscribe(function (response) {
            if (response) {
                _this.overDueCount = response['totalCount'];
            }
        });
    };
    MyTicketsComponent.prototype.getTicketsSearch = function () {
        var _this = this;
        if (this.myTicketsForm.valid && !(this.myTicketsForm.get('ticketNumber').value && this.myTicketsForm.get('email').value)) {
            if (!(this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length > 0)) {
                this.dropdownSettings.statusSelectedItems.push({ id: Status.InProgress, itemName: Status[Status.InProgress] });
                this.statusOnSelectAll = false;
            }
            this._customerservice.SearchTicketsOnPagination(null, [this.userInfo.userId], this.myTicketsForm.value.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.myTicketsForm.value.overDueCount, null, this.myTicketsForm.get('email').value ? this.myTicketsForm.get('email').value : null, this.myTicketsForm.get('email').value ? this.myTicketsForm.get('operatingCountryId').value : null, (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map(function (item) { return item.id; }) : []), false).subscribe(function (response) {
                if (response) {
                    _this.pageCount = response['totalCount'];
                    _this.allTickets = response['content'];
                    _this.myTickets = response['content'];
                    if (_this.allTickets && _this.allTickets.length) {
                        _this.allTickets.forEach(function (x) {
                            if (x.dueDate) {
                                x.dueDate = moment.utc(x.dueDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.createdDate) {
                                x.createdDate = moment.utc(x.createdDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.modifiedDate) {
                                x.modifiedDate = moment.utc(x.modifiedDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                        });
                    }
                }
                else {
                    _this.pageCount = 0;
                    _this.allTickets = [];
                    _this.myTickets = [];
                }
            });
            this.setFocusToTextBox();
        }
    };
    MyTicketsComponent.prototype.onItemSelect = function (item, indexValue) {
        var _this = this;
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                var selectedIds_2 = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(function (item) { return selectedIds_2.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    _this.ticketTypesSort();
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        });
                    }
                    if (type.value === TicketType.Order) {
                        _this.getDisputeReasons();
                        _this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(_this.dropdownSettings.disputeReasonDropdownList));
                    }
                    else {
                        _this.dropdownSettings.disputeReasonDropdownList = [];
                        _this.dropdownSettings.disputeReasonSelectedItem = [];
                    }
                });
                if (this.ticketTypes.length === this.dropdownSettings.typeSelectedItems.length) {
                    this.ticketTypeOnSelectAll = true;
                }
                else {
                    this.ticketTypeOnSelectAll = false;
                }
            }
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
            if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
                this.subTypeOnSelectAll = true;
                this.subTypesSort();
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
                this.statusOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
            if (this.sourceTypes.length === this.dropdownSettings.sourceSelectedItems.length) {
                this.sourceOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
            if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                this.departmentOnSelectAll = true;
            }
            if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                var deptIds = this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; });
                this.getAssignedUsersByDepartments(deptIds);
            }
            else {
                this.dropdownSettings.createdByDropdownList = [];
                this.dropdownSettings.createdBySelectedItems = [];
            }
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
            if (this.ticketPriorities.length === this.dropdownSettings.prioritySelectedItems.length) {
                this.priorityOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            if (this.users.length === this.dropdownSettings.createdBySelectedItems.length) {
                this.createdByOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
            if (this.disputeReason.length === this.dropdownSettings.disputeReasonSelectedItem.length) {
                this.disputeReasonOnSelectAll = true;
            }
        }
    };
    MyTicketsComponent.prototype.onItemDeSelect = function (item, indexValue) {
        var _this = this;
        if (this.dropdownSettings.subTypeIndex === +indexValue) {
            if (this.isDiputeTicketSearch && this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length === 0) {
                this.subTypesSort();
            }
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                var selectedIds_3 = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(function (item) { return selectedIds_3.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    _this.subTypesSort();
                    if (type.value.includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            _this.ticketTypeOnSelectAll = false;
                            _this.ticketTypesSort();
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            _this.ticketTypeOnSelectAll = false;
                            _this.ticketTypesSort();
                        });
                    }
                    if (type.value === TicketType.Order) {
                        _this.getDisputeReasons();
                        _this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(_this.dropdownSettings.disputeReasonDropdownList));
                        _this.disputeReasonOnSelectAll = false;
                    }
                    else {
                        _this.dropdownSettings.disputeReasonDropdownList = [];
                        _this.dropdownSettings.disputeReasonSelectedItem = [];
                        _this.ticketTypeOnSelectAll = false;
                    }
                });
            }
            else if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length === 0 && this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter(function (item) { return item.itemName.includes(TicketType.Order); });
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList = [];
                this.dropdownSettings.disputeReasonSelectedItem = [];
            }
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.showAllTickets) {
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
            }
            else if (this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length === 0) {
                this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.filter(function (item) { return item.id === Status.InProgress; });
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    };
    MyTicketsComponent.prototype.onSelectAll = function (items, indexValue) {
        var _this = this;
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.ticketTypesSort();
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.dropdownSettings.disputeReasonDropdownList = [];
            this.dropdownSettings.disputeReasonSelectedItem = [];
            this.ticketTypes.forEach(function (type) {
                if (type.value.includes('FLP360')) {
                    type.subTypes.forEach(function (subType) {
                        var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                        _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                    });
                }
                else {
                    type.subTypes.forEach(function (subType) {
                        _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                    });
                }
                if (type.value === TicketType.Order) {
                    _this.getDisputeReasons();
                    _this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(_this.dropdownSettings.disputeReasonDropdownList));
                    _this.disputeReasonOnSelectAll = true;
                }
            });
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = true;
            this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }));
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = true;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = true;
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = true;
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = true;
        }
    };
    MyTicketsComponent.prototype.onDeSelectAll = function (items, indexValue) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter(function (item) { return item.itemName.includes(TicketType.Order); });
                this.ticketTypesSort();
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList = [];
                this.dropdownSettings.disputeReasonSelectedItem = [];
            }
        }
        if (this.dropdownSettings.subTypeIndex === +indexValue) {
            if (this.isDiputeTicketSearch && this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length === 0) {
                this.subTypeOnSelectAll = false;
                this.ticketTypesSort();
            }
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    };
    MyTicketsComponent.prototype.clearFields = function () {
        this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
        this.chRef.detectChanges();
        this.myTicketsForm.controls['overDueCount'].enable();
        this.myTicketsForm.reset();
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketStatus();
        this.showAllTickets = true;
        this.getTicketPriorities();
        var element = document.getElementById('ticketType');
        if (element) {
            element.focus();
        }
        this.myTicketsForm.get('operatingCountryId').setValue(this.countryId);
        this.ticketTypeOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.createdByOnSelectAll = true;
        this.disputeReasonOnSelectAll = true;
    };
    MyTicketsComponent.prototype.setFocusToTextBox = function () {
        setTimeout(function () {
            var element = document.getElementById('ticketType');
            var email = document.getElementById('email');
            if (element.value) {
                element.focus();
            }
            else if (email.value) {
                email.focus();
            }
            else {
                element.focus();
            }
        }, 1000);
    };
    MyTicketsComponent.prototype.OnTabSearchFocus = function () {
        var element = document.getElementById('search-button');
        if (element) {
            element.focus();
        }
        event.preventDefault();
    };
    MyTicketsComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        if (this.operatingCountries) {
            var countryInfo = this.operatingCountries.find(function (country) { return country.id === _this.countryId; });
            if (countryInfo) {
                this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
                this.operatingCountries.splice(0, 0, countryInfo);
            }
        }
    };
    MyTicketsComponent.prototype.getAllowedCountries = function () {
        var countryIds = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',').map(function (i) { return +i; });
                if (countryIds.includes(OperatingCountryEnums.USA)) {
                    return OperatingCountryEnums.USA;
                }
                return countryIds[0];
            }
        }
        return OperatingCountryEnums.USA;
    };
    MyTicketsComponent.prototype.goToViewTicket = function (id, ticketNumber) {
        if (this.isTicketView) {
            var ticketTab = new TicketTabInfo();
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = 'View Ticket - ' + ticketNumber;
            ticketTab.viewTicket = true;
            ticketTab.isTeamTicket = false;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    };
    MyTicketsComponent.prototype.getDisputeReasons = function () {
        var _this = this;
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this._customerservice.getDisputeReasons().subscribe(function (response) {
            if (response) {
                _this.disputeReason = response;
                _this.disputeReason.forEach(function (item) {
                    _this.dropdownSettings.disputeReasonDropdownList.push({ id: item.id, itemName: item.value.trim() });
                });
                _this.dropdownSettings.disputeReasonDropdownList.sort(function (item1, item2) {
                    var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) {
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                //   this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
            }
            else {
                _this.disputeReason = [];
                _this.dropdownSettings.disputeReasonDropdownList = [];
                //  this.dropdownSettings.disputeReasonSelectedItem = [];
            }
        });
    };
    return MyTicketsComponent;
}());
export { MyTicketsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/my-tickets.component.ts.pre-build-optimizer.js